import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {candidate_template} from "../components/templates/candidate_template";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class candidate extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected editForm: candidate_template;

    protected getModuleName(){

        return "candidate";
    }

    buildContent() : Array<Element>{

        this.editForm = new candidate_template("editForm", this.viewModel, this);
        return [this.editForm.build()];
    }

    public fillPage() : void{

        this.getUrlVars();
    }

    protected saveCandidate(){

        this.loadingIn(this.editForm.builtTemplate);

        let formReq_url: string = 'api/job/candidate/user/create/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.viewModel));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {
                    let responseParsed = JSON.parse(req.request.response);

                    //console.log("response", responseParsed);

                    let message = "Account successfully created !";

                    if(responseParsed.data == 'user exists'){
                       message = 'You already have an account with us. Please login !';
                       page.redirect('/login');
                    }

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, message);

                    page.redirect('/job/applications');
                })
                obj.loadingOut(obj.editForm.builtTemplate);

            }
        });
        XHRHdl.execute();
    }

    protected cancelCandidate(){
        page.redirect('/');
    }

    protected getUrlVars() {
        let queryString = window.location.search;
        queryString = decodeURIComponent(queryString);
        let urlParams = new URLSearchParams(queryString);

        this.update(urlParams);
    }

    protected onFilterRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){
                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
            });
            obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected update(item){

        let candidate = {
                firstName: item.get('firstName')
               ,lastName: item.get('lastName')
               ,email: item.get('email')
               ,token: item.get('token')
               ,brand : item.get('brand')
               ,idCandidate : item.get('idCandidate')
        };

        this.editForm.setCandidate(candidate);
        this.getFormData(candidate);

    }

    protected getFormData(candidate){

        this.loadingIn(this.editForm.builtTemplate);

        let formReq_url: string = 'api/job/candidate/user/get/';
        let formReq_params: Array<Array<string>> = [];

        formReq_params.push(["data", ko.toJSON({'email': candidate.email,'idCandidate' : candidate.idCandidate})]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    let responseParsed = JSON.parse(req.request.response);
                    console.log("response", responseParsed);
                    if(responseParsed.data.userFound == true){

                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "You already have an account with us, Please Log In!");
                        page.redirect('/login');
                    }

                    obj.editForm.setCountries(responseParsed.data.countries);
                })
                obj.loadingOut(obj.editForm.builtTemplate);

            }
        });
        XHRHdl.execute();
    }
}


// WEBPACK FOOTER //
// ./js/modules/candidate.ts